import React, { useState, useEffect, useRef } from "react";
import DataTable from "../components/DataTable";
import SnackbarAlert from "../components/SnackbarAlert";
import { Box, TextField, IconButton, Tooltip, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, TableCell, TableRow, TableBody, TableContainer, Paper, Table, TableHead } from "@mui/material";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PaymentsIcon from "@mui/icons-material/Payments";
export default function CheckoutOrder() {
    const printRef = useRef();
    const [orders, setOrders] = useState([]);
    const [orderDetails, setOrderDetails] = useState([]);
    const [search, setSearch] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [selectedOrderNo, setSelectedOrderNo] = useState("");
    const [selectedCourierName, setSelectedCourierName] = useState("");
    const [statusModal, setStatusModal] = useState(false);
    const [openAddressModal, setOpenAddressModal] = useState(false);
    const [openImg, setOpenImg] = useState(false);
    const [shippingStatus, setShippingStatus] = useState("");
    const [addressDetails, setAddressDetails] = useState([]);
    const [selectedImg, setSelectedImg] = useState("")
    const [finalAmount, setFinalAmount] = useState(0);
    const [selectedUser, setSelectedUser] = useState(0);
    const [addressData, setAddressData] = useState([]);
    const [resellerData, setResellerData] = useState([]);
    const [checkingPayment, setCheckingPayment] = useState(false);
    const [paymentDialog, setPaymentDialog] = useState(false);
    const [selectedCheckout, setSelectedCheckout] = useState(null);
    const [paymentId, setPaymentId] = useState("");
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        date.setMinutes(date.getMinutes());
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        hours = String(hours).padStart(2, "0");
        return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    };
    useEffect(() => {
        fetchOrdersData();
    }, []);
    const fetchOrdersData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "checkout";
            const response = await makeRequest("get", url);
            if (response) {
                setOrders(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleViewOrderDetails = async (order) => {
        setAddressData(order)
        setSelectedOrderNo(order?.rfId);
        setSelectedUser(order?.user_id);
        setFinalAmount(order?.final_amount);
        setSelectedCourierName(order?.courier_name);
        setLoading(true);
        try {
            let url = webEndPoint + "checkout/products/" + order?.cart_id;
            const response = await makeRequest("get", url);
            if (response) {
                setOrderDetails(response?.data);
                setOpenModal(true);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleClose = () => {
        setOpenModal(false);
    };
    const handleViewAddress = async () => {
        setOpenAddressModal(true);
    };
    const handlePrint = () => {
        const content = printRef.current;
        if (!content) return;
        const printWindow = window.open("", "_blank");
        printWindow.document.open();
        printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>Print Label</title>
            <style>
                @page {
                    size: A6;
                    margin: 5mm;
                }
                body {
                    margin: 0;
                    padding: 0;
                    font-family: Arial, sans-serif;
                }
                .a6-label {
                    width: 100%;
                    font-size: 14px;
                    line-height: 1.3;
                }
                .section {
                    padding: 6px;
                    margin-bottom: 6px;
                }
                .title {
                    font-weight: bold;
                    font-size: 14px;
                    margin-bottom: 4px;
                }
                .from * {
                    font-size: 14px !important;
                    margin: 1px 0 !important;
                }
                .to * {
                    font-size: 18px !important;
                    margin: 1px 0 !important;
                }
                .section * {
                    margin: 1px 0 !important;
                }
            </style>
        </head>
        <body>
            ${content.innerHTML}
        </body>
        </html>
    `);
        printWindow.document.close();
        printWindow.onload = function () {
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                printWindow.onafterprint = () => {
                    printWindow.close();
                };
            }, 300);
        };
    };
    const subtotal = orderDetails?.reduce((sum, o) => { return sum + Number(o.total_price || 0); }, 0);
    const totalQty = orderDetails?.reduce((sum, o) => { return sum + Number(o.quantity || 0); }, 0);
    const discount = 0;
    const totalAmount = subtotal - discount;
    const shippingCharges = finalAmount - subtotal;
    const filteredState = orders?.filter((d) =>
        d?.mobile_number?.toLowerCase().includes(search?.toLowerCase()) || d?.first_name?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "Checkout ID", "Checkout Date", "User Name", "Mobile", "Order Amount", "Payment Status", "Remarks", "Actions"];
    const rows = filteredState?.map((o, i) => [i + 1, o.rfId, formatDate(o.created_at), o.first_name, o.mobile_number, o.final_amount, o.payment_status, o.remarks,
    <Box sx={{ display: "flex", gap: 1 }}>
        <Tooltip title="View Order Details"><IconButton color="primary" onClick={() => handleViewOrderDetails(o)}><VisibilityIcon /></IconButton></Tooltip>
        <Tooltip title="Check Payment Status">
            <Button variant="contained" color="success" size="small" onClick={() => handleOpenPaymentDialog(o)}>Check Payment</Button>
        </Tooltip>
    </Box>
    ]);
    const handleOpenPaymentDialog = (order) => {
        setSelectedCheckout(order);
        setPaymentId("");
        setPaymentDialog(true);
    };
    const verifyPayment = async () => {
        if (!paymentId) {
            setMessage("Enter Payment ID");
            setSnackbar(true);
            return;
        }
        try {
            setLoading(true);
            const response = await makeRequest(
                "post",
                webEndPoint + "payment/manual-verify",
                {
                    checkout_id: selectedCheckout.rfId,
                    razorpay_payment_id: paymentId
                }
            );
            if (response.success) {
                setMessage("Payment Verified. Order Created Successfully.");
                setSnackbar(true);
                setPaymentDialog(false);
                fetchOrdersData();
            }
        } catch (err) {
            setMessage(err.response?.data?.message || "Verification Failed");
            setSnackbar(true);
        } finally{
            setLoading(false);
        }
    };
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Chceckout Orders</Typography>
            <Box
                sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "95%", }}>
                <TextField label="Search By Mobile Number / User Name" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "60%", md: 600 } }} />
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="md">
                {/* <DialogTitle>Order List</DialogTitle> */}
                <DialogTitle>{`Order List : (Order No - SA${selectedOrderNo ?? ""}`})</DialogTitle>
                <DialogContent>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>S.No</TableCell>
                                    <TableCell>Product Name</TableCell>
                                    <TableCell>Product Image</TableCell>
                                    <TableCell>Color Name</TableCell>
                                    <TableCell>Age</TableCell>
                                    <TableCell>Size</TableCell>
                                    <TableCell>Price</TableCell>
                                    <TableCell>Quantity</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {orderDetails?.map((o, i) => (
                                    <TableRow key={o.rfId}>
                                        <TableCell>{i + 1}</TableCell>
                                        <TableCell>{o.product_name}</TableCell>
                                        <TableCell>
                                            {o.color_image_url ? (
                                                <img src={o.color_image_url} alt={o.color_name}
                                                    style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "6px", cursor: "pointer" }}
                                                    onClick={() => { setSelectedImg(o.color_image_url); setOpenImg(true); }} />) : ("-")}
                                        </TableCell>
                                        <TableCell>{o.color_name}</TableCell>
                                        <TableCell>{o.age_name}</TableCell>
                                        <TableCell>{o.size_name}</TableCell>
                                        <TableCell>{o.price}</TableCell>
                                        <TableCell>{o.quantity}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <Box sx={{ mt: 2, p: 2, border: "1px solid #eee", borderRadius: 2 }}>
                            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                                Order Summary
                            </Typography>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                <Typography>Subtotal</Typography>
                                <Typography>₹ {subtotal.toFixed(2)}</Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                <Typography>Discount</Typography>
                                <Typography>₹ {discount.toFixed(2)}</Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                <Typography>Shipping Charges</Typography>
                                <Typography>₹ {shippingCharges.toFixed(2)}</Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                <Typography><b>Total Quantity</b></Typography>
                                <Typography><b>{totalQty}</b></Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                <Typography><b>Total Amount</b></Typography>
                                <Typography><b>₹ {finalAmount}</b></Typography>
                            </Box>
                        </Box>
                    </TableContainer>
                    <DialogActions sx={{ mt: 2 }}>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button variant="contained" onClick={() => handleViewAddress()}>View Address</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <Dialog open={openAddressModal} onClose={() => setOpenAddressModal(false)} fullWidth maxWidth="sm">
                <DialogTitle>Delivery Address</DialogTitle>
                <DialogContent>
                    {addressData ? (
                        <Box ref={printRef} className="a6-label">
                            <Box className="section to">
                                {/* <Typography className="title">Order No : {selectedOrderNo}, Courier : {selectedCourierName}</Typography> */}
                                <Typography className="title">TO</Typography>
                                <Typography>{addressData?.user_name}</Typography>
                                <Typography>
                                    {addressData?.address_line1}, {addressData?.address_line2}
                                </Typography>
                                <Typography>{addressData?.city}</Typography>
                                <Typography>
                                    {addressData?.district_name}, {addressData?.state_name} - {addressData?.pincode}
                                </Typography>
                                <Typography>{addressData?.mobile_number}</Typography>
                            </Box>
                        </Box>

                    ) : (
                        <CircularProgress />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handlePrint} variant="contained">Print</Button>
                    <Button onClick={() => setOpenAddressModal(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={paymentDialog} onClose={() => setPaymentDialog(false)} fullWidth maxWidth="sm">
                <DialogTitle>Verify Razorpay Payment</DialogTitle>
                <DialogContent>
                    <Typography sx={{ mb: 2 }}>Checkout ID : {selectedCheckout?.rfId}</Typography>
                    <TextField fullWidth label="Razorpay Payment ID" placeholder="pay_xxxxxxxxxxxxx" value={paymentId} onChange={(e) => setPaymentId(e.target.value)} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setPaymentDialog(false)}>Cancel</Button>
                    <Button variant="contained" onClick={verifyPayment}>Verify Payment</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}